const resources = {
    free: 'FREE',
    biFreeShip: 'Beauty Insiders enjoy *FREE standard shipping* on all orders.'
};

module.exports = function getResource(label) {
    return resources[label];
};
